import React from "react";

const NotificationsCount = ({
  count,
  marginLeftCls='ml-2',
  textCls='text-xs',
  roundedCls='rounded-none',
  paddingCls='p-1',
  ...rest
}) => {

  if (!count)
    return null;

  const cls = `bg-red-500 text-white font-semibold leading-none shadow pointer-events-none ${paddingCls} ${textCls} ${marginLeftCls} ${roundedCls}`
  return (
    <span className={cls} {...rest}>
      {count > 10 ? '10+' : count}
    </span>
  )
}

export default NotificationsCount;